import React from "react"
import styled from "@emotion/styled"
import { RichText } from "prismic-reactjs"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

const SlideshowContainer = styled("div")`
  padding-bottom: 64px;

  & .slick-slide {
    height: 80vh;
    max-height: 800px;

    div {
      height: 100%;
    }

    & div.SliderContentWrapper {
      position: relative;
    }
  }

  & .slick-next {
    right: 50px;
    z-index: 1;
  }

  & .slick-prev {
    left: 50px;
    z-index: 1;
  }

  & .slick-dots {
    bottom: 30px;
  }

  & .slick-dots li button::before {
    opacity: 1;
    font-size: 10px;
  }

  & .slick-dots li.slick-active button::before {
    color: white;
  }

  & .slick-prev::before,
  .slick-next::before {
    color: white;
    font-size: 80px;
    font-family: "freight-sans-pro", sans-serif;
    font-weight: 300;
    line-height: 0;
  }

  & .slick-prev::before {
    content: "‹";
  }

  & .slick-next::before {
    content: "›";
  }

  & img {
    margin: auto;
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  @media (max-width: 768px) {
    & .slick-prev::before,
    .slick-next::before {
      display: none;
    }

    margin-bottom: 120px;
    padding-bottom: 0px;
  }
`

const SlideshowHeadline = styled("div")`
  position: absolute;
  top: 43%;
  left: 37%;
  max-width: 800px;

  z-index: 2;

  & h1 {
    margin: 0;
  }

  @media (max-width: 1280px) {
    top: 38%;
  }

  @media (max-width: 800px) {
    top: 480px;
    left: 200px;
  }

  @media (max-width: 768px) {
    left: 10%;
    top: 43%;
  }
`

// Settings for Slick slider
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  swipe: true,
  touchMove: true,
}

const SliderSection = ({ galleryImages, title }) => {
  return (
    <SlideshowContainer className="imageWrapper">
      <Slider {...settings}>
        {galleryImages.map((image, i) => {
          return (
            <div className="SliderContentWrapper" key={i}>
              <SlideshowHeadline>
                {RichText.render(image.image_title)}
              </SlideshowHeadline>
              <img src={image.gallery_image.url + "&w=2000"} alt={title} />
            </div>
          )
        })}
      </Slider>
    </SlideshowContainer>
  )
}

export default SliderSection
